// extracted by mini-css-extract-plugin
export default {"root":"matches_contstraints-module___root___fd2d23b5"};